/* Size-guide mobile view switcher (Size chart ↔ How to measure).
   Per-guide: each guide remembers its own state; toggling one does not
   affect the others. No persistence — defaults to "table" on each load. */

(function () {
  function toggleGuide(guide, view) {
    const body = guide.querySelector('.size-guide-page__guide-body');
    if (!body) return;
    body.dataset.sgmViewActive = view;
    guide.querySelectorAll('[data-sgm-view]').forEach((btn) => {
      const active = btn.dataset.sgmView === view;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function init() {
    document.querySelectorAll('.size-guide-page__guide').forEach((guide) => {
      guide.querySelectorAll('[data-sgm-view]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const view = btn.dataset.sgmView === 'howto' ? 'howto' : 'table';
          toggleGuide(guide, view);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
